class NewReferenceCtrl {
  constructor(FlashService, SchemaService, AuthService, TemplateService, EventService) {
    'ngInject';
    this.fs = FlashService;
    this.ss = SchemaService;
    this.as = AuthService;
    this.ts = TemplateService;
    this.es = EventService;
    
    this.loadingGranted = '';
    this.tables = [];
  }

  async $onInit() {
    [this.PROVIDER, this.td] = await Promise.all([
      this.as.getProviderSettings(),
      this.ts.getTemplateData()
    ]);
    this.templateId = this.ts.templateId;

    this.ts.subscribeUpdate(async options => {
      this.ts.updateTemplateData(this.td, options);
      if (!options.keys?.length || options.keys.includes('appId')) {
        await this.initializeDropdown(options.newValue.template.appId);
      }
    }, 'TEMPLATE_DATA_UPDATED_NEWREF');

    this.initializeDropdown(this.td.template.appId);
  }

  async initializeDropdown(appId) {
    await this.initTables(appId);
    if (!this.td.template.references.length && !this.td.template.published) {
      $('#new-reference').find('[data-toggle=dropdown]').dropdown('toggle');
    }
  }

  async initTables(appId) {
    if(this.td.template.published){ return }
    try {
      const allDbs = await this.ss.getGrantedDBs();
      this.tables = allDbs
        .filter(db => (!this.PROVIDER.handleAppsIndependently || db.appId === appId) && !!db.tableName)
        .sort((a, b) => ((a.tableName || '').toLowerCase() > (b.tableName || '').toLowerCase()) ? 1 : -1);
      if (!this.tables.length) {
        this.fs.error(`There are no tables available!`);
        this.noTablesAvailable = true;
      }
      this.loadingGranted = '';
    } catch (error) {
      this.fs.error(`Could not load Schema: ${error}`);
    }
  }

  async addTable(table) {
    this.reference = {};
    this.loadingRef = 'Loading schema...';
    const newTableId = this.td.template.references
      .filter(ref => table.tableId === ref.tableId)
      .reduce((acc, ref) => {
        const strTokens = ref.name.split(' ');
        const refCount = parseInt(strTokens[strTokens.length - 1]);
        acc = Math.max(refCount, acc);
        return acc;
      }, 0);

    let newReference = this.ts.initializeNewObject({
      "templateId": this.templateId,
      "name": `${table.tableName} ${newTableId + 1}`,
      "tableId": table.tableId,
      "realm": this.td.template.realm,
      "provider": this.td.template.provider,
      "genActions": { print: false, submit: true, update: true }
    });
    newReference.tableSchema = { id: table.tableId };

    newReference.tableSchema = 
      this.td.template.references.find(ref =>  ref.tableId === table.tableId)?.tableSchema ||
      await this.ss.getSchema(this.td.template, table.tableId);

    this.td.template.references.push(newReference);

    this.ts.notifyUpdate(["references"], this.td);

    this.es.dispatchEvent(
      this.es.actions.REFERENCE_SELECT_BEGIN,
      { referenceId: newReference.id });

    this.loadingRef = '';
    this.reference = newReference;
    this.fs.success(`Table '${newReference.name}' was added`);
  }

  unpublishTemplate() {
    if (this.ts.templateHasChanges(this.td.template)) {
      this.fs.error('Please save your changes first!');
      return;
    }
    if (!confirm("WARNING: Unpublishing a Template may break existing links and event hooks (if you add or remove target tables afterwards).  Do you want to continue (proceeding will SAVE your template)?")) return;
    this.td.template.published = false;
    this.es.dispatchEvent(this.es.actions.SAVE_TEMPLATE, null);
  }
}

export default {
  bindings: {
    reference: '=',
    loadingRef: '='
  },
  templateUrl: 'form-builder/build-wizard/new-reference/new-reference.component.html',
  controller: NewReferenceCtrl
};
